import { render, staticRenderFns } from "./register-prospect.vue?vue&type=template&id=032acf5b&"
import script from "./register-prospect.vue?vue&type=script&lang=js&"
export * from "./register-prospect.vue?vue&type=script&lang=js&"
import style0 from "./register-prospect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports